import { render, staticRenderFns } from "./shipping-add-or-update.vue?vue&type=template&id=3f314f38&"
import script from "./shipping-add-or-update.vue?vue&type=script&lang=js&"
export * from "./shipping-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports